import { render, staticRenderFns } from "./SimpleMainDetail.vue?vue&type=template&id=043f0b8d&scoped=true"
import script from "./SimpleMainDetail.vue?vue&type=script&lang=js"
export * from "./SimpleMainDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043f0b8d",
  null
  
)

export default component.exports